import React from "react";
import { ClipboardCheckIcon, NetworkIcon, Table2Icon, FileTextIcon, RulerIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { resources, ResourceIcon } from "../../data/content";
const iconMap: Record<ResourceIcon, React.ComponentType<{
  className?: string;
}>> = {
  clipboard: ClipboardCheckIcon,
  tooth: NetworkIcon,
  table: Table2Icon,
  file: FileTextIcon,
  ruler: RulerIcon
};
export function Resources() {
  return <section className="w-full bg-white px-4 py-16 sm:py-20" data-id="element-265" data-mp="1ixlu9awgwgds">
      <div className="mx-auto max-w-4xl" data-id="element-266" data-mp="1ex1x47bw9crn">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-ink sm:text-4xl" data-id="element-267" data-mp="1ewaedx3eb9is">
          And You’ll Also Receive Immediate Access To:
        </h2>
        <div className="mx-auto mt-6 max-w-xl rounded-2xl bg-navy px-6 py-6 text-center" data-id="element-268" data-mp="1nr6xpigty2kd">
          <p className="font-display text-5xl font-black text-cta" data-id="element-269" data-mp="22o7e4ptkmb3j">30+</p>
          <p className="mt-1 font-display text-xl font-black text-white" data-id="element-270" data-mp="1xpe1t0q0sq4y">Restorative Planning Resources</p>
          <p className="mt-2 text-[15px] text-mist" data-id="element-271" data-mp="1akbd7nfzwqm3">A collection of educational resources designed to help you organize the major considerations involved in post-endodontic restoration.</p>
        </div>

        <ul className="mt-10 divide-y divide-slate-200" data-id="element-272" data-mp="1jiwwjktak9nx">
          {resources.map(r => {
          const Icon = iconMap[r.icon];
          return <li key={r.title} className="flex gap-4 py-5" data-id="element-273" data-mp="1ti5n03oy765j">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand/15" data-id="element-274" data-mp="1thvsq3wvecu1">
                  <Icon className="h-6 w-6 text-brand-deep" data-id="element-275" data-mp="1yf4ai3e3weur" />
                </span>
                <div data-id="element-276" data-mp="238gx67z86bkv">
                  <h3 className="font-display text-lg font-black text-ink" data-id="element-277" data-mp="23abab0498zee">{r.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-slate-600" data-id="element-278" data-mp="27bn1vb6ovup8">{r.text}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-6 text-center text-[17px] font-semibold text-slate-700" data-id="element-279" data-mp="2h8i1xyim235m">
          Whatever endodontically treated tooth you’re evaluating, you’ll have a structured place to organize your findings and review the factors that matter.
        </p>

        <div className="mt-10" data-id="element-280" data-mp="qv0chxyepink">
          <CTAButton label="I want access to the complete system" data-id="element-281" data-mp="qwbqsrpha8sx" />
        </div>
      </div>
    </section>;
}